import React from 'react';

/**
 * SEO — leverages React 19's native document metadata hoisting.
 * Renders <title>, <meta>, and <link> tags that React 19 automatically hoists to <head>.
 *
 * Usage:
 *   <SEO title="Contact | Consultium Group" description="..." path="/contact" />
 */
const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://consultiumgroup.co.za').replace(/\/$/, '');
const DEFAULT_DESCRIPTION =
  'Consultium Group — Company registrations, tax clearance, BEE, and compliance services in South Africa. Fast, affordable, expert-run.';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title = 'Consultium Group | Company Registration & Compliance',
  description = DEFAULT_DESCRIPTION,
  path = '/',
  image = DEFAULT_OG_IMAGE,
  noindex = false,
}) => {
  const canonical = `${SITE_URL}${path === '/' ? '/' : path.replace(/\/$/, '')}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Consultium Group" />
      <meta property="og:locale" content="en_ZA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
};

export default SEO;
